import React from "react"
import DataTable from "../DataTable/DataTable"
import HousekeepingStatusBoardHeader from "./HousekeepingStatusBoardHeader"
import HousekeepingStatusBoardStore from './stores/HousekeepingStatusBoardStore'
import HousekeepingStatusBoardActions from './actions/HousekeepingStatusBoardActions'
import { parseISO } from 'date-fns';
import WeeklyDashboard from '../Dashboard/WeeklyDashboard'
import MonthlyDashboard from '../Dashboard/MonthlyDashboard'

class HousekeepingStatusBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getStateFromStores()
    this._onChange = this._onChange.bind(this)
    this.dataTableRef = React.createRef();
  }

  componentDidMount() {
    HousekeepingStatusBoardStore.addChangeListener(this._onChange);
    HousekeepingStatusBoardActions.init(this.props);
    if (this.props.currentDate) {
      this.setState({
        afterMount: true
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.dataTableEndpoint != prevState.dataTableEndpoint) {
      if (this.dataTableRef.current) {
        this.dataTableRef.current.loadData();
      }
    }

    // Handle activeTab changes
    if (this.state.activeTab !== prevState.activeTab) {
      this.fetchStatusBoardData();
    }

    // Handle date changes
    const currentDate = this.state.currentDate instanceof Date ? this.state.currentDate.toISOString().split('T')[0] : this.state.currentDate;
    const prevDate = prevState.currentDate instanceof Date ? prevState.currentDate.toISOString().split('T')[0] : prevState.currentDate;
    
    if (currentDate !== prevDate) {
      this.fetchStatusBoardData();
    }
  }

  fetchStatusBoardData() {
    const { activeTab, currentDate } = this.state;
    const formattedDate = currentDate instanceof Date ? currentDate.toISOString().split('T')[0] : currentDate;
    
    HousekeepingStatusBoardActions.setLoading(true);

    $.ajax({
      type: 'GET',
      url: '/admin/housekeeping-status-board',
      dataType: 'json',
      data: {
        view: activeTab,
        date: formattedDate
      },
      success: (data) => {
        HousekeepingStatusBoardActions.updateBoardData(data);
      },
      error: (xhr, status, err) => {
        console.error('Error fetching status board data:', err);
      },
      complete: () => {
        HousekeepingStatusBoardActions.setLoading(false);
      }
    });
  }

  getStateFromStores() {
    return {
      activeTab: HousekeepingStatusBoardStore.getActiveTab(),
      currentDate: HousekeepingStatusBoardStore.getCurrentDate(),
      dataTableEndpoint: HousekeepingStatusBoardStore.getDataTableEndpoint(),
      dateFormat: HousekeepingStatusBoardStore.getDateFormat(),
      loading: HousekeepingStatusBoardStore.getLoading(),
      readOnly: HousekeepingStatusBoardStore.getReadOnly(),
      reservationSegments: HousekeepingStatusBoardStore.getReservationSegments(),
      requestCleaningPath: HousekeepingStatusBoardStore.getRequestCleaningPath(),
      timeFormat: HousekeepingStatusBoardStore.getTimeFormat(),
      dateData: HousekeepingStatusBoardStore.getDateData(),
      roomTypes: HousekeepingStatusBoardStore.getRoomTypes(),
    };
  }

  render() {
    var currentDate = this.state.currentDate

    if (this.props.currentDate && !this.state.afterMount) {
      currentDate = parseISO(this.props.currentDate)
    }

    return (
      <div className="housekeeping-status-board">
        <HousekeepingStatusBoardHeader {...this.state} dateFormat={this.props.dateFormat} timeFormat={this.props.timeFormat} currentDate={currentDate} />
        
        <div className="row">
          <div className="col-md-12">
            {this.state.activeTab === "daily" ? (
              <DataTable
                ref={this.dataTableRef}
                endpoint={this.state.dataTableEndpoint}
                no_data_text={I18n.t('none')}
                currency_unit={I18n.t('number.currency.format.unit')}
                delimiter={I18n.t('number.currency.format.delimiter')}
                separator={I18n.t('number.currency.format.separator')}
                date_format={this.state.dateFormat}
                time_format={this.state.timeFormat}
              />
            ) : null}

            {this.state.activeTab === "weekly" ? (
              <WeeklyDashboard
                path={this.state.dataTableEndpoint}
                dateData={this.state.dateData}
                roomTypes={this.state.roomTypes}
                reservationSegments={this.state.reservationSegments}
                currentDate={currentDate}
                dateFormat={this.state.dateFormat}
                timeFormat={this.state.timeFormat}
                readOnly={this.state.readOnly}
                onExpandCollapseRoomType={HousekeepingStatusBoardActions.onExpandCollapseRoomType}
                isHousekeeping={true}
                show_housekeeping={true}
              />
            ) : null}

            {this.state.activeTab === "monthly" ? (
              <MonthlyDashboard
                currentDate={currentDate}
                dateData={this.state.dateData}
                roomTypes={this.state.roomTypes}
                reservationSegments={this.state.reservationSegments}
                dateFormat={this.state.dateFormat}
                timeFormat={this.state.timeFormat}
                readOnly={this.state.readOnly}
                onExpandCollapseRoomType={HousekeepingStatusBoardActions.onExpandCollapseRoomType}
                isHousekeeping={true}
                show_housekeeping={true}
              />
            ) : null}
          </div>
        </div>

        {this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
      </div>
    );
  }

  _onChange() {
    this.setState(this.getStateFromStores());
  }
}

export default HousekeepingStatusBoard